<template>
  <div :class="'custom-tooltip-status'+tData.status">
    <div class="tooltip_view_box">
      <template v-if="tData.status==1">
        <div class="close_status1"
             @click="hideCustomTooltip">
          关闭
        </div>

        <div class="title">
          {{ tData.factory_name }}
        </div>

        <div class="content_status1">
          <div>地址：{{ tData.address }}</div>
          <div class="content_two_box">
            <div style="width: 50%;">在职员工：{{ tData?.census_data?.count_online_user }}</div>
            <div style="width: 50%;">兼职员工：{{ tData?.census_data?.count_free_user }}</div>
          </div>
          <div class="content_two_box">
            <div style="width: 50%;">
              {{ timeLabelLocal }}有效付款订单总数：{{ tData?.census_data?.count_order }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}有效付款总金额：{{ tData?.census_data?.sum_pay_amount }}
            </div>
          </div>
          <div>{{ timeLabelLocal }}有效付款预估服务费：{{ tData?.census_data?.sum_service_amount }}</div>
          <div class="content_two_box">
            <div style="width: 50%;">
              {{ timeLabelLocal }}发货总数：{{ tData?.census_data?.count_express_sample }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}申样达人：{{ tData?.census_data?.distinct_talent_num }}
            </div>
          </div>
          <div class="content_two_box">
            <div style="width: 50%;">{{ timeLabelLocal }}申样总数：{{
                tData?.census_data?.count_sample
              }}
            </div>
            <div style="width: 50%;">
              {{ timeLabelLocal }}出单达人：{{ tData?.census_data?.count_distinct_customer }}
            </div>
          </div>
        </div>
      </template>
      <!--其他状态-->
      <template v-else>
        <div class="close_status2" @click="hideCustomTooltip">关闭</div>
        <div class="title">
          {{ tData.factory_name }}
        </div>
        <div class="content_status2">场地筹备中，尽情期待</div>
      </template>

      <div v-if="tData.status==1" class="status">
        正在运营
      </div>
      <div v-if="tData.status==2" class="status">
        即将开放
      </div>
      <div v-if="tData.status==3" class="status">
        规划中
      </div>
    </div>
  </div>

</template>


<script>
export default {
  props: {
    tData: {
      type: Object,
      default: {}
    },
    timeLabelLocal: {
      type: String,
      default: ''
    },
    hideCustomTooltip: {
      type: Function,
      default: () => {
      }
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  beforeDestroy() {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>

.tooltip_view_box {
  padding: 0 20px;

  .close_status1 {
    position: absolute;
    right: 7px;
    cursor: pointer;
    pointer-events: auto; /* 允许关闭按钮接收鼠标事件 */
  }

  .close_status2 {
    position: absolute;
    top: 5px;
    right: 12px;
    cursor: pointer;
    pointer-events: auto; /* 允许关闭按钮接收鼠标事件 */
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    padding-top: 10px;
  }

  .content_status1 {
    height: 190px;
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    gap: 8px;
  }

  .content_status2 {
    height: 84px;
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    gap: 8px;
  }

  .content_two_box {
    display: flex;
  }

  .status {
    text-align: center;
    color: black;
    font-size: 18px;
    font-weight: 700;
  }
}


.custom-tooltip-status0 {
  width: 580px;
  height: 270px;
  background: url(../../assets/_s-image_map_operation.png) no-repeat;
  background-size: 580px 270px;
}

.custom-tooltip-status1 {
  width: 580px;
  height: 270px;
  background: url(../../assets/_s-image_map_operation.png) no-repeat;
  background-size: 580px 270px;
}

.custom-tooltip-status2 {
  width: 480px;
  height: 170px;
  background: url(../../assets/_s-image_map_openness.png) no-repeat;
  background-size: 480px 170px;
}

.custom-tooltip-status3 {
  width: 580px;
  height: 270px;
  background: url(../../assets/_s-image_map_plan.png) no-repeat;
  background-size: 580px 270px;
}
</style>